import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import _t from 'i18n!nls/enterprise-learning-path-description-page';

export type TimeDuration = { value: number; unit: 'minute' | 'hour' };

const DurationMessage = ({ timeDuration }: { timeDuration: TimeDuration }) => (
  <FormattedMessage
    message={
      timeDuration.unit === 'minute'
        ? _t('{timeDuration, plural, =1 {# minute} other {# minutes}}')
        : _t('{timeDuration, plural, =1 {# hour} other {# hours}}')
    }
    timeDuration={timeDuration.value}
  />
);

export default DurationMessage;
